/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { DeviceModel } from '../../../core/device';
import { Locale, LocaleKeys } from '../../../core/locale';

import './EmptyGuideMessage.scss';

const EmptyGuideMessage: FunctionComponent = () => {
    const noShowsSelectedText = Locale.getString(LocaleKeys.EMPTY_GUIDE_NOT_SELECTED_FAVORITE);
    const howToSelectText = Locale.getString(LocaleKeys.EMPTY_GUIDE_HOW_TO_SELECT_FAVORITE);
    const selectDifferentChannelListText = Locale.getString(
        LocaleKeys.EMPTY_GUIDE_SELECT_DIFFERENT_CHANNEL_LIST,
    ).replace('BUTTON_NAME', DeviceModel.isWebOsPlatform() ? 'OK' : 'SELECT');

    return (
        <div className="empty-guide-message">
            <p className="empty-guide-paragraph">{noShowsSelectedText}</p>
            <p className="empty-guide-paragraph">{selectDifferentChannelListText}</p>
            <p className="empty-guide-paragraph">{howToSelectText}</p>
        </div>
    );
};

export default EmptyGuideMessage;
